import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Navbar.css";
import logo from "./logo.png";
// import VisitorIndex from '../../VisitorIndex';

const NavBar = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="navbar-fixed">
      <nav className="white" role="navigation">
        <div className="nav-wrapper container">
          <Link id="logo-container" to="/" className="brand-logo">
            <img
              src={logo}
              style={{ height: 50, width: 160, paddingTop: 10 }}
              alt="header logo"
            />
          </Link>
          <ul className="right hide-on-med-and-down">
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/solution">Solutions</Link>
            </li>
            <li>
              <Link to="/">Service</Link>
            </li>
            <li>
              <Link to="/about">About</Link>
            </li>
            <li>
              <Link to="/">Contact</Link>
            </li>
          </ul>

          <ul id="nav-mobile" className="sidenav">
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/solution">Solutions</Link>
            </li>
            <li>
              <Link to="/">Service</Link>
            </li>
            <li>
              <Link to="/about">About</Link>
            </li>
            <li>
              <Link to="/">Contact</Link>
            </li>
          </ul>
          <a href="/" data-target="nav-mobile" className="sidenav-trigger">
            <i className="material-icons">menu</i>
          </a>
        </div>
      </nav>
    </div>
  );
};

export default NavBar;
